import { Component } from '@angular/core';
import { CaptureHistoryItemTypeClientChoreUpdatedComponent } from '../capture-history-item-type-client-chore-updated/capture-history-item-type-client-chore-updated.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';


@Component({
  selector: 'app-capture-history-item-type-client-chore-started',
  templateUrl: '../capture-history-item-type-client-chore-updated/capture-history-item-type-client-chore-updated.component.html',
  imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeClientChoreStartedComponent
  extends CaptureHistoryItemTypeClientChoreUpdatedComponent {

  get title() {
    return "Chore Update Started";
  }
}
